import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import InstallmentTable from './InstallmentTable';
import { formMessageConstants } from '../../../utils/constants/form-message-constants';
import { isEmpty } from '../../../utils/obj-utils';

function PaymentSummary({ paymentSummary, noPaymentSummaryFoundText, country }) {
    function displayPaymentSummary() {
        const isPaymentSummaryEmpty = isEmpty(paymentSummary);
        const foundCountry = getCountry();
        return (
            <div className='payment-summary'>
                <h2>{formMessageConstants.paymentSummary}</h2>
                <div className='summary-container'>
                    {isPaymentSummaryEmpty ?
                        <div className='no-files'>
                            <p className='info'>{noPaymentSummaryFoundText}</p>
                        </div> :
                        <Fragment>
                            <p>
                                <span className='left'>{formMessageConstants.amountInvoiced}</span>
                                <span className='right'>{paymentSummary.formattedAmountInvoiced}</span>
                            </p>
                            <InstallmentTable installments={paymentSummary.installments}></InstallmentTable>
                            <br />
                            <p>
                                <span className='left'>{formMessageConstants.totalAmountPaid}</span>
                                <span className='right'>{paymentSummary.formattedTotalAmountPaid}</span>
                            </p>
                            <p>
                                <span className='left'>{formMessageConstants.paymentMethod}</span>
                                <span className='right'>{paymentSummary.paymentMethod}</span>
                            </p>
                            <p>
                                <span className='left'>{formMessageConstants.lastStatus}</span>
                                <span className='right'>{paymentSummary.lastStatus}</span>
                            </p>
                            <p>
                                <span className='left'>{formMessageConstants.lastPayment}</span>
                                <span className='right'>{paymentSummary.formattedLastPaymentDate}</span>
                            </p>
                            <p>
                                <span className='left'>{formMessageConstants.billingContactName}</span>
                                <span className='right'>{paymentSummary.billingContactName}</span>
                            </p>
                            <p>
                                <span className='left'>{formMessageConstants.billingContactDetails}</span>
                                <span className='right'>{paymentSummary.billingContactDetails}</span>
                            </p>
                            <br />
                            <p>
                                <span className='left'>{formMessageConstants.billingAddress}</span>
                                {isEmpty(paymentSummary.billingAddress) ?
                                    null :
                                    < span className='right'>
                                        {displayAddressLine1()}
                                        {displayAddressLine2()}
                                        {displayAddressLine3()}
                                        {displayCity()}
                                        {displayPostcode()}
                                        {!isEmpty(foundCountry) ? foundCountry.label : paymentSummary.billingAddress.country}
                                    </span>}
                            </p>
                        </Fragment>}
                </div>
            </div >);
    }

    function getCountry() {
        if (isEmpty(paymentSummary)) {
            return formMessageConstants.emptyString;
        }

        return isEmpty(paymentSummary.billingAddress) ?
            formMessageConstants.emptyString :
            country.options.find((option) => option.code === paymentSummary.billingAddress.country);
    }


    function displayAddressLine1() {
        if (isEmpty(paymentSummary.billingAddress.addressLine1)) {
            return null;
        }
        return <Fragment> {paymentSummary.billingAddress.addressLine1} < br ></br ></Fragment>;
    }

    function displayAddressLine2() {
        if (isEmpty(paymentSummary.billingAddress.addressLine2)) {
            return null;
        }
        return <Fragment> {paymentSummary.billingAddress.addressLine2} < br ></br ></Fragment>;
    }

    function displayAddressLine3() {
        if (isEmpty(paymentSummary.billingAddress.addressLine3)) {
            return null;
        }
        return <Fragment> {paymentSummary.billingAddress.addressLine3} < br ></br ></Fragment>;
    }

    function displayCity() {
        if (isEmpty(paymentSummary.billingAddress.city)) {
            return null;
        }
        return <Fragment>{paymentSummary.billingAddress.city} < br ></br ></Fragment >;
    }

    function displayPostcode() {
        if (isEmpty(paymentSummary.billingAddress.postcode)) {
            return null;
        }
        return <Fragment>{paymentSummary.billingAddress.postcode} < br ></br ></Fragment >;
    }

    return displayPaymentSummary();
}

PaymentSummary.propTypes = {
    paymentSummary: PropTypes.object.isRequired,
    country: PropTypes.object.isRequired,
    noPaymentSummaryFoundText: PropTypes.string
};

export default PaymentSummary;
